import { FC } from "react";

import { type SectionEnrollmentData } from "api/api-reporting-types";
import { ScrollableTableContainer } from "components/tables/ScrollableTableContainer";
import { TD, TH, THead, TR, Table } from "components/tables/TableElements";
import { t } from "i18n/i18n";
import { TooltipTrigger } from "mds/components/TooltipTrigger";

type SectionEnrollmentTableProps = {
  data: SectionEnrollmentData[];
};

export const SectionEnrollmentTable: FC<SectionEnrollmentTableProps> = ({ data }) => {
  return (
    <ScrollableTableContainer className="mb-0 max-h-[330px] overflow-y-auto">
      <Table>
        <THead>
          <tr>
            <TH>
              <TooltipTrigger
                content={t("section_enrollment_report.columns.term_tooltip")}
                place="top"
              >
                {t("section_enrollment_report.columns.term")}
              </TooltipTrigger>
            </TH>

            <TH>
              <TooltipTrigger
                content={t("section_enrollment_report.columns.course_tooltip")}
                place="top"
              >
                {t("section_enrollment_report.columns.course")}
              </TooltipTrigger>
            </TH>

            <TH>
              <TooltipTrigger
                content={t("section_enrollment_report.columns.section_title_tooltip")}
                place="top"
              >
                {t("section_enrollment_report.columns.section_title")}
              </TooltipTrigger>
            </TH>

            <TH>
              <TooltipTrigger
                content={t("section_enrollment_report.columns.role_tooltip")}
                place="top"
              >
                {t("section_enrollment_report.columns.role")}
              </TooltipTrigger>
            </TH>

            <TH>
              <TooltipTrigger
                content={t("section_enrollment_report.columns.name_tooltip")}
                place="top"
              >
                {t("section_enrollment_report.columns.name")}
              </TooltipTrigger>
            </TH>

            <TH>
              <TooltipTrigger
                content={t("section_enrollment_report.columns.email_tooltip")}
                place="top"
              >
                {t("section_enrollment_report.columns.email")}
              </TooltipTrigger>
            </TH>

            <TH>
              <TooltipTrigger
                content={t("section_enrollment_report.columns.disabled_status_tooltip")}
                place="top"
              >
                {t("section_enrollment_report.columns.disabled_status")}
              </TooltipTrigger>
            </TH>

            <TH>
              <TooltipTrigger
                content={t("section_enrollment_report.columns.external_user_id_tooltip")}
                place="top"
              >
                {t("section_enrollment_report.columns.external_user_id")}
              </TooltipTrigger>
            </TH>

            <TH>
              <TooltipTrigger
                content={t("section_enrollment_report.columns.external_section_id_tooltip")}
                place="top"
              >
                {t("section_enrollment_report.columns.external_section_id")}
              </TooltipTrigger>
            </TH>

            <TH>
              <TooltipTrigger
                content={t("section_enrollment_report.columns.invite_status_tooltip")}
                place="top"
              >
                {t("section_enrollment_report.columns.invite_status")}
              </TooltipTrigger>
            </TH>
          </tr>
        </THead>

        <tbody>
          {data.map((row) => (
            <TR key={`${row.email}-${row.section_title}`}>
              <TD className="truncate">{row.term}</TD>

              <TD className="truncate">{row.course_code}</TD>

              <TD>{row.section_title}</TD>

              <TD className="truncate">
                <span className="inline-flex items-center rounded-full py-1 text-xs font-medium">
                  {t(`section_enrollment_report.roles.${row.role}`)}
                </span>
              </TD>

              <TD className="truncate">{row.name}</TD>

              <TD className="truncate">{row.email}</TD>

              <TD className="truncate">
                {t(`section_enrollment_report.disabled_status_values.${row.disabled_status}`)}
              </TD>

              <TD className="truncate">{row.external_user_id || "-"}</TD>

              <TD className="truncate">{row.external_section_id || "-"}</TD>

              <TD className="truncate">
                {t(`section_enrollment_report.invite_status.${row.invite_status}`)}
              </TD>
            </TR>
          ))}
        </tbody>
      </Table>
    </ScrollableTableContainer>
  );
};
